module.exports = __webpack_public_path__ + "img/category-fishing-game.4d6ee819.png";